import { useEffect, useRef, useState } from "react";
import commonNetwork from "../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import { FormCheckbox, FormDateSelector, FormSelector } from "../components/FormElements";
import { Button } from "../components/Elements";
import { cronJobValidationScheme } from "../../common/validators/cronJobSettingsFilterScheme";
import Loading from "../components/Loading";
import { DateSelectorRefProps } from "../components/FormElements/FormDate";
import FormObserver from "../components/FormElements/FormObserver";
import { CrnJobFormProps, WorkTypes } from "../../common/types";
import { formatDateOnFront } from "../../lib/helpers";
import { getSelectedValueFromId } from "../../common/helpers/selectBoxHelper";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { OptionModel } from "../../common/types/OptionModel";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";



const workTypes: Array<OptionModel> = [
    {
        value: "hour",
        label: "Saatlik"
    },
    {
        value: "day",
        label: "Günlük"
    }
];
const hourlyWorkPeriond: Array<OptionModel> = [
    {
        label: "1 Saat",
        value: "1"
    },
    {
        label: "6 Saat",
        value: "6"
    },
    {
        label: "12 Saat",
        value: "12"
    }
]
const dailyWorkPeriond: Array<OptionModel> = [
    {
        label: "1 Gün",
        value: "1"
    },
    {
        label: "15 Gün",
        value: "15"
    },
    {
        label: "30 Gün",
        value: "30"
    }
]

const initialValues: CrnJobFormProps = {
    customerCronVisible: false,
    customerWorkType: "hour",
    customerWorkPeriod: "1",
    customerStartDate: "",
    customerStatus: false,
    paymentCronVisible: false,
    paymentWorkType: "hour",
    paymentWorkPeriod: "1",
    paymentStartDate: "",
    paymentStatus: false,
}

const CronJobSettings = () => {

    usePermissionCheck(UserOperationTypes["Erp Entegrasyonu"], "Zamanlanmış Görevler İşlemleri izni yok");
    const paymentCronDateRef = useRef<DateSelectorRefProps>(null);
    const customerCronDateRef = useRef<DateSelectorRefProps>(null);
    const [loading, setLoading] = useState(true);
    const [postLoading, setPostLoading] = useState(false);
    const [formValues, setFormValues] = useState<CrnJobFormProps>(initialValues);
    const [timeUpdateTrigger, setTimeUpdateTrigger] = useState<boolean>(false);

    useEffect(() => {
        selectCurrentCronJobSettings();
    }, []);
    useEffect(() => {

        if (timeUpdateTrigger) {
            updateSelectedDates();
        }
    }, [timeUpdateTrigger]);


    const updateSelectedDates = () => {
        if (formValues.paymentCronVisible) {
            paymentCronDateRef.current?.setDateValue(new Date(formValues.paymentStartDate));
        }
        if (formValues.customerCronVisible) {
            customerCronDateRef.current?.setDateValue(new Date(formValues.customerStartDate));
        }
    }
    const selectCurrentCronJobSettings = async () => {

        const result = await commonNetwork.get("/cronJob");
        setLoading(false);

        if (result.isSuccess) {
            setFormValues(result.data);

            setTimeUpdateTrigger(true);

        } else {
            toast.error(result.errorMessage);
        }
    }



    const onSubmit = async (values: CrnJobFormProps) => {
        setPostLoading(true);
        const result = await commonNetwork.post("/cronJob", values);
        setPostLoading(false);


        if (result.isSuccess) {
            toast.success("Zamanlanmış Görev Tanımları başarılı bir şekilde kaydedildi.");

        } else {
            toast.error(result.errorMessage || "Ayarlar kaydedilirken hata meydana geldi");
        }
    }

    const onChangePaymentCronWorkType = (name: any, type: any) => {

        setFormValues({
            ...formValues,
            paymentWorkType: type,
            paymentWorkPeriod: "1"
        });
    }
    const onChangeCustomerCronWorkType = (name: any, type: any) => {
        setFormValues({
            ...formValues,
            customerWorkType: type,
            customerWorkPeriod: "1"
        });
    }


    const getSummaryDesc = (startDate: string | Date, workPeriod: string, workType: WorkTypes) => {

        let d = new Date(startDate);
        if (d) {
            var date = formatDateOnFront(d);
            const workTypeText = workType == "day" ? "günlük" : "saatlik";
            const workTypePeriodText = workType == "day" ? "günde" : "saatte";

            return (
                <div className="mt-4">
                    <span className="text-normal text-base text-contrast-60 ">
                        Aktarım <b>{date}</b> tarihinden itibaren, her <b>{workPeriod} {workTypePeriodText}</b> bir <b>{workTypeText}</b> aralıkla çalışacaktır.
                    </span>
                </div>
            );
        }

    }



    const paymentWorkPeriods = formValues.paymentWorkType == "day" ? dailyWorkPeriond : hourlyWorkPeriond;
    const customerWorkPeriods = formValues.customerWorkType == "day" ? dailyWorkPeriond : hourlyWorkPeriond;

    if (loading) {
        return (
            <Loading />
        );
    }

    return (
        <div className="w-full">
            <PageTitle title={pageTitleTexts.cronJobSettings} />

            <div className="px-4 py-2 flex flex-col justify-start space-y-2">
                <div className="flex flex-row items-center">
                    <img src={"/icons/zamanlanmis-gorevler-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Zamanlanmış Görev Tanımları
                    </span>
                </div>
            </div>
            <Formik
                initialValues={formValues}
                validate={cronJobValidationScheme}
                onSubmit={onSubmit}
                validateOnMount
            // enableReinitialize
            >
                {({
                    values,
                    setFieldValue,
                }) => (
                    <Form>
                        <FormObserver
                            watch={(values: CrnJobFormProps) => {
                                setFormValues(values)
                            }} />

                        <div className="mx-4 px-4 py-2 mt-1 bg-white shadow-md mb-4 pb-4 rounded-md">
                            {formValues.paymentCronVisible && (
                                <>
                                    <div className="px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4">
                                        <div className="mt-3">
                                            <h1 className="font-bold text-contrast-90">Zamanlanmış Ödeme Aktarımı</h1>
                                            <span className="text-contrast-50 text-md">
                                                Zamanlanmış Ödeme Aktarımı ayarlarını yapınız
                                            </span>
                                        </div>
                                        <div className="w-full col-span-2">
                                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2  ">
                                                <div className="mt-3">
                                                    <FormSelector
                                                        options={workTypes}
                                                        name="paymentWorkType"
                                                        placeholder="Seçiniz"
                                                        label="Çalışma Tipi*"
                                                        defaultValue={getSelectedValueFromId(values.paymentWorkType, workTypes)}
                                                        ///@ts-ignore
                                                        onChange={(name: string, value: string) => {
                                                            onChangePaymentCronWorkType(name, value);
                                                            setFieldValue(name, value);
                                                            setFieldValue("paymentWorkPeriod", "1");
                                                        }}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <FormSelector
                                                        options={paymentWorkPeriods}
                                                        name="paymentWorkPeriod"
                                                        placeholder="Seçiniz"
                                                        label="Çalışma Periyodu*"
                                                        value={getSelectedValueFromId(values.paymentWorkPeriod, paymentWorkPeriods)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                <div className="mt-3">
                                                    <FormDateSelector
                                                        label="Başlangıç Zamanı "
                                                        name="paymentStartDate"
                                                        type="date"
                                                        nullable={true}
                                                        showTimeSelect
                                                        dateFormat="dd.MM.yyyy : HH:mm"
                                                        ref={paymentCronDateRef}

                                                    />
                                                </div>
                                                <div className="mt-10 flex flex-row">
                                                    <FormCheckbox
                                                        label={"Durumu"}
                                                        name="paymentStatus"
                                                        type="checkbox"
                                                        id="paymentStatus"
                                                        onChange={setFieldValue}
                                                    />
                                                </div>
                                            </div>
                                            {getSummaryDesc(values.paymentStartDate, values.paymentWorkPeriod, values.paymentWorkType)}
                                        </div>
                                    </div>
                                    <hr />
                                </>
                            )}

                            {formValues.customerCronVisible && (
                                <div className="px-4 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 mb-4">
                                    <div className="mt-3">
                                        <h1 className="font-bold text-contrast-90">Zamanlanmış Müşteri Aktarımı</h1>
                                        <span className="text-contrast-50 text-md">
                                            Zamanlanmış Müşteri Aktarımı ayarlarını yapınız
                                        </span>
                                    </div>
                                    <div className="w-full col-span-2">
                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2  ">
                                            <div className="mt-3">
                                                <FormSelector
                                                    options={workTypes}
                                                    name="customerWorkType"
                                                    placeholder="Seçiniz"
                                                    label="Çalışma Tipi*"
                                                    defaultValue={getSelectedValueFromId(values.customerWorkType, workTypes)}
                                                    ///@ts-ignore 
                                                    onChange={(name: string, value: string) => {
                                                        onChangeCustomerCronWorkType(name, value);
                                                        setFieldValue(name, value);
                                                        setFieldValue("customerWorkPeriod", "1");
                                                    }}
                                                />
                                            </div>
                                            <div className="mt-3">
                                                <FormSelector
                                                    options={customerWorkPeriods}
                                                    name="customerWorkPeriod"
                                                    placeholder="Seçiniz"
                                                    label="Çalışma Periyodu*"
                                                    value={getSelectedValueFromId(values.customerWorkPeriod, customerWorkPeriods)}
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                            <div className="mt-3">
                                                <FormDateSelector
                                                    label="Başlangıç Zamanı "
                                                    name="customerStartDate"
                                                    type="date"
                                                    dateFormat="dd.MM.yyyy : HH:mm"
                                                    nullable={true}
                                                    showTimeSelect
                                                    ref={customerCronDateRef}
                                                />
                                            </div>
                                            <div className="mt-10 flex flex-row">
                                                <FormCheckbox
                                                    label={"Durumu"}
                                                    name="customerStatus"
                                                    type="checkbox"
                                                    id="customerStatus"
                                                    onChange={setFieldValue}
                                                />
                                            </div>
                                        </div>
                                        {getSummaryDesc(values.customerStartDate, values.customerWorkPeriod, values.customerWorkType)}

                                    </div>
                                </div>
                            )}

                            <hr />

                            <div className="mt-3 text-end mr-3">
                                <Button
                                    type="submit"
                                    color="primary"
                                    hover="primary"
                                    size="xs"
                                    disabled={postLoading}
                                    loading={postLoading}
                                >
                                    Gönder
                                </Button>
                            </div>
                        </div>


                    </Form>
                )}
            </Formik>
        </div>
    );
}
export default CronJobSettings;